export const MuiAvatar = {
    styleOverrides: {
        root: { fontSize: "16px", fontWeight: 400, lineHeight: "16px", letterSpacing: "0.14px" }
    }
};
//# sourceMappingURL=Avatar.js.map